import dayjs from "dayjs";

const roundToNearest30Minutes = (date: dayjs.Dayjs, type: "floor" | "ceil") => {

    const minutes = date.minute();
    if (type === "floor") {
        if (minutes < 30) {
            return date.minute(0).second(0);
        } else {
            return date.minute(30).second(0);
        }
    } else {
        if (minutes > 30) {
            return date.add(1, 'hour').minute(0).second(0);
        } else {
            return date.minute(30).second(0);
        }
    }
};

export default roundToNearest30Minutes;